import React from 'react';
import { Portal } from '../../Configs';
import { portal } from '../../Configs/general';
import ConstructorRequestGDC from './ConstructorRequest.GDC';

const ConstructorRequest = props => {
  switch (portal) {
    case Portal.Gascaribe:
      return <ConstructorRequestGDC {...props} />;

    default:
      return <></>;
  }
};

export default ConstructorRequest;
